/*
Glue
*/
import filters from '@/modules/standardItems/schemas/shopSupplies/filters'
import headers from '@/modules/standardItems/schemas/shopSupplies/headers'

const name = 'Glue'
const id = 'gxEAXloGGhrWS5GbH185'

export default {
  name,
  id,
  filters,
  headers
}
